module.exports = "/assets/data/5ab03a07b25bf0aa2e4bb6c14abc15ac-WC1R.data.json";